import { render, staticRenderFns } from "./StatisticsChar.vue?vue&type=template&id=710aacfc&"
import script from "./StatisticsChar.vue?vue&type=script&lang=js&"
export * from "./StatisticsChar.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsChar.vue?vue&type=style&index=0&id=710aacfc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports